// extracted by mini-css-extract-plugin
export default {"clientNav":"client-nav_clientNav__tW1-Z"};